module.exports = __webpack_public_path__ + "37342d4a16f7f4abe099389a79636735.png";